import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './NavChevron.styles'

const NavChevron = ({ dir, goToView, hide, imageStyle, dataTest }) => {
  const chevronIconProps = { height: '18px', width: '18px', dir }

  return (
    <Styled.ChevronButton
      dir={dir}
      title={dir === 'left' ? 'Previous' : 'Next'}
      hide={hide}
      onClick={() => goToView(dir)}
      data-test={`${dataTest}-chevron-${dir}`}
      imageStyle={imageStyle}
    >
      <Styled.ChevronIcon {...chevronIconProps} />
    </Styled.ChevronButton>
  )
}

NavChevron.propTypes = {
  dataTest: PropTypes.string,
  dir: PropTypes.string,
  goToView: PropTypes.func.isRequired,
  hide: PropTypes.bool,
  imageStyle: PropTypes.oneOf(['square', 'landscape'])
}

NavChevron.defaultProps = {
  dir: 'right',
  hide: false,
  dataTest: 'm052'
}

export default NavChevron
